<template>
	<div class="bg-gray-light rounded-full p-1 overflow-hidden w-full">
		<div class="tabs flex w-full">
			<button
				v-for="option in props.options"
				:key="option.id"
				:class="[
					'tabs__btn btn text-primary-superdark rounded-full flex-1 p-2',
					isActive(option.id)
						? 'tabs__btn--active'
						: 'hover:bg-gray focus:bg-gray'
				]"
				:title="option.text"
				@click.prevent="setActivate(option.id)"
			>
				{{ option.text }}
			</button>
		</div>
	</div>
</template>

<script setup lang="ts">
import type { Model, Props, Option } from '@/types/Tabs'

const model = defineModel<Model>({ required: true })
const props = defineProps<Props>()

const isActive = (optionId: Option['id']) => {
	return optionId === model.value
}

const setActivate = (optionId: Option['id']) => {
	model.value = optionId
}
</script>

<style scoped lang="postcss">
@reference '../main.css';

@supports (position-anchor: --anchor) {
	/* "active" tab background slider */
	.tabs {
		@apply relative isolate after:absolute after:bg-white after:h-full after:rounded-full after:inset-0 after:-z-1 after:transition-all;
	}

	.tabs__btn--active {
		anchor-name: --tab-link;
	}

	.tabs::after {
		position-anchor: --tab-link;
		inset-inline-start: anchor(start);
		inset-inline-end: anchor(end);
	}
}

@supports not (position-anchor: --anchor) {
	/* fallback to classical background color */
	.tabs__btn--active {
		@apply bg-white;
	}
}
</style>
